import { Badge } from '@material-ui/core';

import { AVATAR_TYPE, type AvatarType } from 'src/data/persona';

import { IconEmptyAvatar } from './components/EmptyAvatar';
import { PersonaAvatarEight } from './components/PersonaAvatarEight';
import { PersonaAvatarFive } from './components/PersonaAvatarFive';
import { PersonaAvatarFour } from './components/PersonaAvatarFour';
import { PersonaAvatarNine } from './components/PersonaAvatarNine';
import { PersonaAvatarOne } from './components/PersonaAvatarOne';
import { PersonaAvatarSeven } from './components/PersonaAvatarSeven';
import { PersonaAvatarSix } from './components/PersonaAvatarSix';
import { PersonaAvatarTen } from './components/PersonaAvatarTen';
import { PersonaAvatarThree } from './components/PersonaAvatarThree';
import { PersonaAvatarTwo } from './components/PersonaAvatarTwo';
import styles from './PersonaAvatar.module.scss';

const getAvatarComponent = (avatarType?: AvatarType | null) => {
  switch (avatarType) {
    case AVATAR_TYPE.avatarOne:
      return PersonaAvatarOne;
    case AVATAR_TYPE.avatarTwo:
      return PersonaAvatarTwo;
    case AVATAR_TYPE.avatarThree:
      return PersonaAvatarThree;
    case AVATAR_TYPE.avatarFour:
      return PersonaAvatarFour;
    case AVATAR_TYPE.avatarFive:
      return PersonaAvatarFive;
    case AVATAR_TYPE.avatarSix:
      return PersonaAvatarSix;
    case AVATAR_TYPE.avatarSeven:
      return PersonaAvatarSeven;
    case AVATAR_TYPE.avatarEight:
      return PersonaAvatarEight;
    case AVATAR_TYPE.avatarNine:
      return PersonaAvatarNine;
    case AVATAR_TYPE.avatarTen:
      return PersonaAvatarTen;
    default:
      return IconEmptyAvatar;
  }
};

interface PersonaAvatarProps {
  /** Goes on the avatar icon, so callers size it with `font-size`. */
  className?: string;
  /** Without one, the avatar is the empty one that stands for the broad audience. */
  avatarType?: AvatarType | null;
  opaqueBackground?: boolean;
  hasBadge?: boolean;
}

export const PersonaAvatar = ({
  className,
  avatarType,
  opaqueBackground = false,
  hasBadge = false,
}: PersonaAvatarProps) => {
  const Component = getAvatarComponent(avatarType);

  return (
    <Badge
      className={styles.root}
      classes={{ dot: styles.dot }}
      variant="dot"
      overlap="circular"
      invisible={!hasBadge}
      color="primary"
    >
      <Component
        className={className}
        opaque={opaqueBackground}
      />
    </Badge>
  );
};
